define('SuiteCommerce.OrderStatus.OrderFinder.Router', [
	'SuiteCommerce.OrderStatus.OrderFinder.SearchForm.View',
	'SuiteCommerce.OrderStatus.OrderFinder.SearchResults.View',
	'SuiteCommerce.OrderStatus.OrderFinder.Order.Model',
	'SuiteCommerce.OrderStatus.Utils',
	'Backbone',
	'underscore',
], function define(SearchForm, SearchResults, OrderModel, Utils, Backbone, _) {
	'use strict';
	return Backbone.Router.extend({
		initialize: function initialize(application) {
			this.application = application;
			this.model = new OrderModel();
			this.isBootstrappingOrderDetailsFromUrl = false;
			this.orderLookupParametersFromUrl = null;
			this.setupOrderDetailsListener();
		},
		routes: function routes() {
			var dynamicRoutes = {};
			dynamicRoutes[this.getOrderFinderRoute() + '(/)'] = 'openOrderFinderPage';
			dynamicRoutes[this.getOrderDetailsRoute() + '(/)'] = 'openOrderDetailsPage';
			dynamicRoutes[this.getOrderDetailsRoute() + '/:ordernumber(/)'] = 'openOrderDetailsPage';
			return dynamicRoutes;
		},
		getOrderFinderRoute: function getOrderFinderRoute() {
			return Utils.getConfigurationParameter('route');
		},
		setGuestRedirectError: function setGuestRedirectError(ordernumber) {
			this.model.set(
				{
					ordernumber: (ordernumber || '').trim(),
					redirectError: 'invalidOrderDetails',
				},
				{ silent: true }
			);
		},
		openOrderFinderPage: function openOrderFinderPage() {
			var self = this;
			Utils.resolveIsUserLoggedIn().then(function resolveLoggedInStatus(isLoggedIn) {
				var view;
				if (isLoggedIn) {
					Utils.redirectToCustomerCenter(Utils.getPurchasesHashtag());
					return;
				}
				view = new SearchForm({
					application: self.application,
					model: self.model,
				});
				view.showContent();
			});
		},
		getOrderDetailsRoute: function getOrderDetailsRoute() {
			return Utils.getConfigurationParameter('route') + '/details';
		},
		openOrderDetailsPage: function openOrderDetailsPage(ordernumber) {
			var self = this;
			Utils.resolveIsUserLoggedIn().then(function resolveLoggedInStatus(isLoggedIn) {
				var searchResults;
				if (isLoggedIn) {
					self.handleLoggedInOrderDetailsRoute(ordernumber);
					return;
				}
				if (_.keys(self.model.get('details')).length > 0) {
					searchResults = new SearchResults({
						application: self.application,
						model: self.model,
					});
					searchResults.showContent();
					return;
				}
				if (self.isGuestOrderDetailsDirectAccessEnabled()) {
					if (self.bootstrapOrderDetailsFromUrl(ordernumber)) {
						return;
					}
					self.setGuestRedirectError(ordernumber);
				}
				Backbone.history.navigate(self.getOrderFinderRoute(), { trigger: true });
			});
		},
		isGuestOrderDetailsDirectAccessEnabled: function isGuestOrderDetailsDirectAccessEnabled() {
			return Utils.getConfigurationParameter('enableGuestOrderDetailsDirectAccess') !== false;
		},
		handleLoggedInOrderDetailsRoute: function handleLoggedInOrderDetailsRoute(ordernumber) {
			var orderLookupParameters = this.getOrderLookupParametersFromUrl(ordernumber);
			if (!orderLookupParameters) {
				this.orderLookupParametersFromUrl = null;
				this.model.clear({ silent: true });
				Utils.redirectToCustomerCenter(Utils.getPurchasesHashtag());
				return;
			}
			this.orderLookupParametersFromUrl = orderLookupParameters;
			this.model.set({ details: {} }, { silent: true });
			if (this.bootstrapOrderDetailsFromUrl(ordernumber)) {
				return;
			}
			Utils.redirectToCustomerCenter(Utils.getPurchasesHashtag());
		},
		bootstrapOrderDetailsFromUrl: function bootstrapOrderDetailsFromUrl(ordernumber) {
			var self = this;
			var orderLookupParameters = this.getOrderLookupParametersFromUrl(ordernumber);
			if (!orderLookupParameters) {
				return false;
			}
			if (this.isBootstrappingOrderDetailsFromUrl) {
				return true;
			}
			this.isBootstrappingOrderDetailsFromUrl = true;
			this.orderLookupParametersFromUrl = orderLookupParameters;
			this.model.set({
				ordernumber: orderLookupParameters.ordernumber,
				verificationfield: orderLookupParameters.verificationfield,
				details: {},
			});
			this.showOrderDetailsLoadingPage();
			this.model.save().fail(function bootstrapOrderDetailsFromUrlFailed() {
				self.isBootstrappingOrderDetailsFromUrl = false;
				self.model.clear({ silent: true });
				Utils.resolveIsUserLoggedIn().then(function resolveLoggedInStatus(isLoggedIn) {
					if (isLoggedIn) {
						Utils.redirectToCustomerCenter(Utils.getPurchasesHashtag());
						return;
					}
					self.setGuestRedirectError(
						self.orderLookupParametersFromUrl && self.orderLookupParametersFromUrl.ordernumber
					);
					Backbone.history.navigate(self.getOrderFinderRoute(), { trigger: true });
				});
			});
			return true;
		},
		// eslint-disable-next-line complexity
		getOrderLookupParametersFromUrl: function getOrderLookupParametersFromUrl(ordernumber) {
			var queryParameters = Utils.getQueryParameters();
			var normalizedOrdernumber = (ordernumber || '').trim();
			var email = (queryParameters.email || '').trim();
			var zipcode = (queryParameters.zipcode || '').trim();
			var verificationfield = email || zipcode;
			var verificationfieldParameterName = email ? 'email' : 'zipcode';
			if (!normalizedOrdernumber || !verificationfield) {
				return null;
			}
			return {
				ordernumber: normalizedOrdernumber,
				verificationfield: verificationfield,
				verificationfieldParameterName: verificationfieldParameterName,
			};
		},
		getOrderDetailsUrl: function getOrderDetailsUrl() {
			var route = this.getOrderDetailsRoute();
			var orderLookupParameters = this.orderLookupParametersFromUrl || {
				ordernumber: this.model.get('ordernumber'),
				verificationfield: this.model.get('verificationfield'),
			};
			var queryString;
			if (!orderLookupParameters || !orderLookupParameters.ordernumber) {
				return route;
			}
			route += '/' + encodeURIComponent(orderLookupParameters.ordernumber);
			if (!orderLookupParameters.verificationfield || !orderLookupParameters.verificationfieldParameterName) {
				return route;
			}
			queryString = encodeURIComponent(orderLookupParameters.verificationfieldParameterName);
			queryString += '=' + encodeURIComponent(orderLookupParameters.verificationfield);
			return route + '?' + queryString;
		},
		redirectToPurchaseDetails: function redirectToPurchaseDetails(orderDetails) {
			Utils.redirectToCustomerCenter(
				Utils.getPurchaseDetailsHashtag(orderDetails && orderDetails.type, orderDetails && orderDetails.id)
			);
		},
		showOrderDetailsLoadingPage: function showOrderDetailsLoadingPage() {
			var searchResults = new SearchResults({
				application: this.application,
				model: this.model,
				isLoading: true,
			});
			searchResults.showContent();
		},
		setupOrderDetailsListener: function setupOrderDetailsListener() {
			var self = this;
			this.model.on('sync', function navigateToOrderDetailsPage() {
				self.isBootstrappingOrderDetailsFromUrl = false;
				Utils.resolveIsUserLoggedIn().then(function resolveLoggedInStatus(isLoggedIn) {
					if (isLoggedIn) {
						self.redirectToPurchaseDetails(self.model.get('details'));
						return;
					}
					Backbone.history.navigate(self.getOrderDetailsUrl(), { trigger: true });
				});
			});
			this.model.on('destroy', function navigateToOrderFinderPage() {
				self.model.clear();
				self.orderLookupParametersFromUrl = null;
				Backbone.history.navigate(self.getOrderFinderRoute(), { trigger: true });
			});
		},
	});
});
